export const CAMERA_LIMITS = Object.freeze({
  minZoom: 0.05,
  maxZoom: 8,
  /** Multiplicative step used by keyboard/button zoom. */
  zoomStep: 1.2,
  /** Wheel delta → zoom factor sensitivity. */
  wheelZoomSensitivity: 0.0015,
});

export const DEFAULT_CAMERA = Object.freeze({
  position: Object.freeze({ x: -200, y: -120 }),
  zoom: 1,
});
